export default "__VITE_PUBLIC_ASSET__47002a47__"